const smsUnsubscribeForm = document.getElementById('sms-unsubscribe-form'),
      phoneInput = document.getElementById('phone'),
      countryInput = document.getElementById('Country'),
      submitButton = smsUnsubscribeForm.querySelector('button[type="submit"]'),
      responseMessage = document.getElementById('response-message'),
      frends_url = "https://otava-cloudprodcrossplat-agent.frendsapp.com",
      phonePattern = /^\+?[0-9]{9,15}$/; // The pattern to test against

// Disable submit button intially if input does not match the pattern
submitButton.disabled = !phonePattern.test(phoneInput.value);

// Event listener for input changes
phoneInput.addEventListener('input', function() {
  // Enable or disable the submit button based on the pattern match
  submitButton.disabled = !phonePattern.test(phoneInput.value);
  // If the input is valid (or has become valid), clear the response message
  if (phoneInput.validity.valid) {
    responseMessage.textContent = '';
    responseMessage.removeAttribute('style');
  }
});

// Submit event listener
smsUnsubscribeForm.addEventListener('submit', async function(e) {
  e.preventDefault();

  // Clear the response message if it's a valid submission
  responseMessage.textContent = '';
  responseMessage.removeAttribute('style');

  // Disable the form elements during submission
  phoneInput.disabled = true;
  submitButton.disabled = true;
  submitButton.textContent = 'Lähettää...';

  const phoneNumber = convertPhoneNumber(phoneInput.value, countryInput.value);

  try {
    const response = await fetch(frends_url + '/api/markkinointi/v1/smsperuutukset', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phone: phoneNumber })
    });

    if (response.ok) {
      const data = await response.json();
      responseMessage.textContent = 'Tekstiviestimarkkinointi peruttu.';
      responseMessage.style.color = 'green';
      responseMessage.style.display = 'block';
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('Error:', error);
    responseMessage.textContent = 'Virhe markkinointiluvan peruuttamisessa. Ole hyvä ja yritä uudelleen.';
    responseMessage.style.color = 'red';
    responseMessage.style.display = 'block';
  } finally {
    // Re-enable the form elements after submission
    phoneInput.disabled = false;
    phoneInput.value = '';
    submitButton.disabled = !phonePattern.test(phoneInput.value);
    submitButton.textContent = 'Peruuta tilaus';
  }
});

function convertPhoneNumber(phoneNumber, countryCode) {
  if (!phoneNumber) {
    return null;
  }
  let phone = phoneNumber.trim().replace(/\s+/g, '').replace(/-/g, ''),
      code = '+' + countryCode;
  if (phone.substring(0, code.length) !== code) {
    if (phone.indexOf('+') !== -1) {
      return null;
    } else if (phone.charAt(0) === '0') {
      phone = code + phone.substring(1);
    } else {
      phone = code + phone;
    }
  }
  return phone;
}
